// extracted by mini-css-extract-plugin
export default {"root":"Header_root__STLDI","menu":"Header_menu__Ladhn","menuitem":"Header_menuitem__t1Ta+","signUpBtn":"Header_signUpBtn__CcQ2u"};